import {
  BANK_CORESPONDENTS_LOADING,
  SET_BANK_CORESPONDENTS,
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  loading: false,
  isError: false,
};

const BankCorespondent = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_BANK_CORESPONDENTS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case BANK_CORESPONDENTS_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    default:
      return state;
  }
};

export default BankCorespondent;
